import { http, HttpResponse } from 'msw';

export const decryptHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/decrypt', async ({ request }) => {
        const payload = await (await request.blob()).text();
        return HttpResponse.json(JSON.parse(atob(payload)));
    }),
];
